import * as Yup from 'yup'

export const CAUSA_INTERRUPCAO_OUTRA = 'OUTRA'

export const interrupcaoAtendimentoSchema = Yup.object().shape({
  dhInicio: Yup.string().required('Informe quando a interrupção começou.'),
  retomada: Yup.boolean().required(),
  dhFim: Yup.string().when('retomada', {
    is: true,
    then: (schema) =>
      schema
        .required('Informe o fim da interrupção quando a consulta foi retomada.')
        .test(
          'fim-apos-inicio',
          'O fim da interrupção não pode ser anterior ao início.',
          (dhFim, context) => !dhFim || !context.parent.dhInicio || dhFim >= context.parent.dhInicio
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
  quemCaiu: Yup.object().nullable().required('Informe quem perdeu a conexão.'),
  causa: Yup.object().nullable().required('Selecione a causa da interrupção.'),
  causaDetalhe: Yup.string()
    .trim()
    .when('causa', {
      is: (causa: { value?: string } | null) => causa?.value === CAUSA_INTERRUPCAO_OUTRA,
      then: (schema) => schema.required('Descreva a causa quando ela não estiver na lista.'),
      otherwise: (schema) => schema.notRequired(),
    }),
})
